"use strict";

import {//fnSignformatter,
//fnHideOnClickOutside,
//fnRegreArray,
//fnPegaDataUTCNum,
//fnTextoEntreTags,
//fnFmtData,
//fnCampoValidoParaExibicao,
fnDescItem,
//fnPegaStatus,
//fnPegaStatusChecagem,
//fnQueryInstIdData,
fnConfigPeriodicidade} from './fn'


var INSTRUMENT_STORE = {
  state: {
    queryData: null,
    data: {},
    descItem: null,
    userCtx: null,
    usuarioGerencia: false,
    instrumentos: {},
    db: undefined,
    faixas: [],
    status: undefined,
    configPeriodicidade: undefined,
    funcoes: undefined,
    Analises: undefined,
    isLanding: null,
    online: navigator.onLine,
    usuarioTemAdminRole: null,
    landingScroll: null,
    //ATENCAO, este formato de data nao é compativel com o moment.
    //Verificar a rotina para inserir instrumentos caso ocorra alguma alteracao aqui, 
    // pois será necessario alterar o formato de conversao desta data para o formato que é registrado
    // no banco de dados
    flatpickrCfg: {dateFormat: 'd/m/Y', maxDate: (new Date().setUTCHours(23,59,59,999))}, //equivalente do moment: DD/MM/YYYY
    flatpickrCfgChecagem: {dateFormat: 'd/m/Y', width: '150'}, //equivalente do moment: DD/MM/YYYY
    modals: {
      confirmaGravaConfFormVisivel: false,
      confirmarRemoverUsuario: false,
      novoUsuarioDialog: false,
      configDialog: false,
      ocorrenciasActive: false,
      solicitarActive: false,
      gerenciandoUsuarios: false,
      helpFaixa: false,
      helpTendencia: false,
      helpRegra: false,
      helpFormulas: false,
      helpDados: false,
      termosDeUso: false,
      novoInstrumento: false,
      confirmarRemoverInstrumento: false,
      confirmarRemoverCertificado: false,
      exibicaoRapida: false,
      privacidade: false
    }
  },
  update (data) {
    this.state.data = data
    const inst = data.inst
    
    // Periodicidade do item

    var configPeriodicidade = fnConfigPeriodicidade(
      data.config.filter((item) => !!item.periodicidade), inst.AlPeriodoCalibracao, inst.AlTipoPeriodo)

    this.state.configPeriodicidade = configPeriodicidade
    
    // Descrição do item
    this.state.descItem = fnDescItem(inst)

    this.state.faixas = []
    if (data.seriesDenormRes) {
      // Status para aparecer na barra de navegacao
      //this.state.status = fnPegaStatus(data.seriesDenormRes[0].dataUltimaCal, configPeriodicidade)
      
      var faixasSeries = data.seriesDenormRes.map((item) => {
        return {
          DescFaixa: item.DescFaixa,
          CodigoFaixaModelo: item.CodigoFaixaModelo
        }
      })
      this.state.faixas = _.uniqBy(faixasSeries, 'CodigoFaixaModelo')
    }
  },
  updateInstrumentos (data) {
    this.state.instrumentos = data
  }
};


export {INSTRUMENT_STORE}